import { withBemMod } from '@bem-react/core';

import { cnButton } from '../../Button.cn';

import './Button_view_brand.css';

export type WithViewBrandProps = {
    view?: 'brand';
};

export const withViewBrand = withBemMod<WithViewBrandProps>(cnButton(), {});
